import { Component, Input } from '@angular/core';
import {
    ChangeRequestTemplateDisplayOptions,
    ChangeRequestTemplateFieldOptions,
} from '@app/types/translatables/change-request-template-display.options';
import { BaseForm } from '@forms/base.form';
import { ChangeRequestTemplate } from '@models/change-requests/change-request-template.model';
@Component({
    templateUrl: './change-request-template.form.html',
    selector: 'app-change-request-template-form',
    styleUrls: ['./change-request-template.style.scss'],
})
export class ChangeRequestTemplateForm extends BaseForm {
    changeRequestTemplateFields = ChangeRequestTemplateFieldOptions;

    @Input() changeRequestTemplate: ChangeRequestTemplate;

    ChangeRequestTemplateDisplayOptions = ChangeRequestTemplateDisplayOptions;
}
